
// IE não possui forEach para DOM
const each = (elementos, callback) => {
  for (let i = 0; i < elementos.length; i++) {
    callback(elementos[i], i);
  }
};

const eachInverse = (elementos, callback) => {
  const leng = elementos.length;
  for (let i = leng - 1; i >= 0; i--) {
    const element = elementos[i];
    callback(elementos[i], i);
  }
};

function criarEsqueletoGaleria() {

  // criar elementos
  const container = document.createElement('div');
  const interno = document.createElement('div');
  const legenda = document.createElement('div');
  const ul = document.createElement('ul');
  const controles = document.createElement('div');
  const anterior = document.createElement('div');
  const proximo = document.createElement('div');


  // classes dos elementos
  container.className = 'cm-carrossel';
  interno.className = 'slider-container';
  legenda.className = 'legend';
  controles.className = 'controls';
  anterior.className = 'btn-arrow-prev shadow';
  proximo.className = 'btn-arrow-next shadow';


  // adicionando filhos
  interno.appendChild(ul);
  interno.appendChild(controles);

  controles.appendChild(anterior);
  controles.appendChild(proximo);

  container.appendChild(interno);
  container.appendChild(legenda);

  return {
    container,
    ul,
    anterior,
    proximo,
  };
}

function abstrairImagensGaleria(nos: NodeList) {
  const imagens = [];
  each(nos, (galeria, id) => {
    const itens = galeria.querySelectorAll('.gallery-item');
    imagens[id] = [];

    each(itens, (item) => {
      const legendaElemento = item.querySelector('.gallery-caption');
      const imagem = item.querySelector('img');
      imagem.alt = legendaElemento && legendaElemento.innerHTML || '';
      imagens[id].push(imagem);
    });
  });

  // retnoro:
  // [ 0: [ <img ...>, <img ...> ], ... ]
  return imagens;
}

function criarGaleriasViaObjeto(galerias, galeriasDOM) {
  for (let i = 0; i < galerias.length; i++) {
    const galeria = galerias[i];
    const { container, ul, anterior, proximo } = criarEsqueletoGaleria();
    const galeriaAtual = galeriasDOM[i];

    galeriaAtual.parentNode.insertBefore(container, galeriaAtual);

    galeria.forEach((imagem, indice) => {
      const li = document.createElement('li');
      li.appendChild(imagem);
      ul.appendChild(li);
    });

    anterior.addEventListener('click', onClickAnterior);
    proximo.addEventListener('click', onClickProximo);

    ativarItemCarrossel(container, 0);
  }
}

function removerListaNos(nos: NodeList) {
  eachInverse(nos, el => el.parentNode.removeChild(el));
}

function ativarItemCarrossel(galeriaDOM, indice) {
  const lis = galeriaDOM.querySelectorAll('li');
  const legenda = galeriaDOM.querySelector('.legend');
  const img = lis[indice].querySelector('img');
  const legendaStr = img.alt.trim() ? ` - ${img.alt.trim()}` : '';
  const window = galeriaDOM.ownerDocument.defaultView || galeriaDOM.ownerDocument.parentWindow;
  each(lis, (li) => li.classList.remove('active'));
  lis[indice].classList.add('active');
  if (window.screen.availWidth <= 375) {
    img.width = window.screen.availWidth;
    img.height = window.screen.availWidth;
    galeriaDOM.style.width = '100%';
  } else {
    galeriaDOM.style.width = `${img.width + 2}px`;
  }
  legenda.innerHTML = `<strong>${indice + 1}/${lis.length}</strong> ${legendaStr}`;
}

function onClickAnterior() {
  const carrossel = this.parentNode.parentNode.parentNode;
  const lista = carrossel.querySelectorAll('li');
  let indiceAnterior = 0;

  eachInverse(lista, (li, i) => {
    if (li.classList.contains('active') && i > 0) {
      indiceAnterior = i - 1;
    }
  });
  ativarItemCarrossel(carrossel, indiceAnterior);
}

function onClickProximo() {
  const carrossel = this.parentNode.parentNode.parentNode;
  const lista = carrossel.querySelectorAll('li');
  const leng = lista.length;
  let proximoIndice = leng - 1;

  each(lista, (li, i) => {
    if (li.classList.contains('active') && leng - 1 > i) {
      proximoIndice = i + 1;
    }
  });
  ativarItemCarrossel(carrossel, proximoIndice);
}

export function CarregarCarrosselDOM(seletor: string) {
  const main = document.querySelector(seletor);
  const galeriasDOM = main.querySelectorAll('.gallery');
  const objetoGalerias = abstrairImagensGaleria(galeriasDOM);
  criarGaleriasViaObjeto(objetoGalerias, galeriasDOM);
  removerListaNos(galeriasDOM);
}
